import API from "./api";

// ==========================================
// Get All Notifications
// ==========================================

export const getNotifications = async (
    page = 1,
    limit = 20
) => {

    const res = await API.get(

        `/notifications?page=${page}&limit=${limit}`

    );

    return res.data;

};

// ==========================================
// Get Unread Count
// ==========================================

export const getUnreadCount = async () => {

    const res = await API.get(

        "/notifications/unread-count"

    );

    return res.data;

};

// ==========================================
// Mark Notification As Read
// ==========================================

export const markAsRead = async (
    notificationId
) => {

    const res = await API.patch(

        `/notifications/${notificationId}/read`

    );

    return res.data;

};

// ==========================================
// Mark All Notifications As Read
// ==========================================

export const markAllAsRead = async () => {

    const res = await API.patch(

        "/notifications/read-all"

    );

    return res.data;

};

// ==========================================
// Delete Notification
// ==========================================

export const deleteNotification = async (
    notificationId
) => {

    const res = await API.delete(

        `/notifications/${notificationId}`

    );

    return res.data;

};

// ==========================================
// Clear All Notifications
// ==========================================

export const clearNotifications = async () => {

    const res = await API.delete(

        "/notifications/clear"

    );

    return res.data;

};